import React from 'react';
const SystemPermissionsConfig = {
    settings: {
        layout: {}
    },
    routes: [
        {
            path: '/apps/system-permissions',
            component: React.lazy(() => import('./SystemPermissions'))
        }
    ]
};

export default SystemPermissionsConfig;
